class FestivalCountdown extends HTMLElement {
  constructor() {
    super();

    this.attachShadow({ mode: 'open' });

    // Get attributes or use defaults
    this.targetDate = this.getAttribute('target-date') || '2023/12/31';
    this.daysText = this.getAttribute('days-text') || 'Days';
    this.hoursText = this.getAttribute('hours-text') || 'Hours';
    this.minutesText = this.getAttribute('minutes-text') || 'Minutes';
    this.secondsText = this.getAttribute('seconds-text') || 'Seconds';

    // Initial display values
    this.daysInitial = this.getAttribute('days-initial') || '0';
    this.hoursInitial = this.getAttribute('hours-initial') || '0';
    this.minutesInitial = this.getAttribute('minutes-initial') || '0';
    this.secondsInitial = this.getAttribute('seconds-initial') || '0';

    // Setup shadow DOM
    this.render();

    // Start countdown
    this.startCountdown();
  }

  connectedCallback() {
    // clearInterval(this.intervalId);
    // Element added to the DOM
    if (!this.initialized) {
      this.initialized = true;
    }
  }

  disconnectedCallback() {
    // Element removed from DOM
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  startCountdown() {
    this.updateCountdown(); // Run once immediately
    this.intervalId = setInterval(() => this.updateCountdown(), 1000);
  }

  updateCountdown() {
    const now = new Date().getTime();
    const targetTime = new Date(this.targetDate).getTime();
    const distance = targetTime - now;

    if (distance > 0) {
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      this.shadowRoot.querySelector('.days').innerHTML = `<span>${Math.floor(days / 10)}</span><span>${days % 10}</span>`;
      this.shadowRoot.querySelector('.hours').innerHTML = `<span>${Math.floor(hours / 10)}</span><span>${hours % 10}</span>`;
      this.shadowRoot.querySelector('.minutes').innerHTML = `<span>${Math.floor(minutes / 10)}</span><span>${minutes % 10}</span>`;
      this.shadowRoot.querySelector('.seconds').innerHTML = `<span>${Math.floor(seconds / 10)}</span><span>${seconds % 10}</span>`;
    }
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
        }
        
        .countdown-timer {
          display: flex;
          justify-content: center;
          margin-bottom: 4rem;
        }
        
        .countdown-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          flex: 0 0 8rem;
        }
        
        .countdown-value {
                  font-size: 2.6rem;
                  line-height: 1;
                  color: black;
                  height: 4rem;
                  line-height: 4rem;
                  display: flex;
                  flex: 1;
                  width: 7rem;
                  justify-content: center;
                  gap: 0.6rem;
        } 
        .countdown-value span {
          flex: 1;
          background-color: rgba(255, 255, 255, 0.3);
          filter: blur(0.5px);
        }
        .countdown-label {
          font-size: 1.6rem;
          text-transform: uppercase;
          margin-bottom: 1rem;
          color: #fff;
          text-transform: uppercase;
        }
          @media screen and (min-width: 769px) and (max-width: 1023px) {
            .countdown-value {
              font-size: 2.6rem;
              line-height: 1;
              color: black;
              height: 6rem;
              line-height: 6rem;
              display: flex;
              flex: 1;
              width: 9rem;
              justify-content: center;
              gap: 0.8rem;
            }
            .countdown-timer {
              gap: 1.2rem;
            }
          }
          @media screen and (max-width: 768px) {
            .countdown-value {
              width: 7rem;
              font-size: 3rem;
              height: 5rem;
              line-height: 5rem;
            }
            .countdown-timer {
              gap: 0.8rem;
            }
            .countdown-item {
              flex: 0 0 7rem;
            }
          }
      </style>
      
      <div class="countdown-timer">
        <div class="countdown-item">
          <span class="countdown-label">${this.daysText}</span>
          <span class="countdown-value days">${this.daysInitial}</span>
        </div>
        <div class="countdown-item">
          <span class="countdown-label">${this.hoursText}</span>
          <span class="countdown-value hours">${this.hoursInitial}</span>
        </div>
        <div class="countdown-item">
          <span class="countdown-label">${this.minutesText}</span>
          <span class="countdown-value minutes">${this.minutesInitial}</span>
        </div>
        <div class="countdown-item">
          <span class="countdown-label">${this.secondsText}</span>
          <span class="countdown-value seconds">${this.secondsInitial}</span>
        </div>
      </div>
    `;
  }
}

customElements.define('festival-countdown', FestivalCountdown);
// js/helper/event.js
function triggerEvent(element, name, data = {}) {
  element.dispatchEvent(
    new CustomEvent(name, {
      bubbles: true,
      detail: data,
    })
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.loadContent.bind(this)(false);
    // const poster = this.querySelector('[id^="Deferred-Poster-"]');
    // if (!poster) return;
    // poster.addEventListener("click", this.loadContent.bind(this));
  }
  isVideoInViewport() {
    const videoElement = this.querySelector("video");
    if (!videoElement) return false;
    const rect = videoElement.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
  connectedCallback() {
    const playBtn = this.querySelector(".play-button");

    playBtn.addEventListener("click", () => {
      this.querySelector(".history-video").style.zIndex = "0";
      this.querySelector(".history-video").style.opacity = "0";
      this.querySelector("video").play();
    });
  }
  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }

      // Workaround for safari iframe bug
      const formerStyle = deferredElement.getAttribute("style");
      deferredElement.setAttribute("style", "display: block;");
      window.setTimeout(() => {
        deferredElement.setAttribute("style", formerStyle);
      }, 0);
    }
  }
}

customElements.define("deferred-media", DeferredMedia);


// js/helper/throttle.js
function throttle(callback, delay3 = 15) {
  let throttleTimeout = null,
    storedEvent = null;
  const throttledEventHandler = (event) => {
    storedEvent = event;
    const shouldHandleEvent = !throttleTimeout;
    if (shouldHandleEvent) {
      callback(storedEvent);
      storedEvent = null;
      throttleTimeout = setTimeout(() => {
        throttleTimeout = null;
        if (storedEvent) {
          throttledEventHandler(storedEvent);
        }
      }, delay3);
    }
  };
  return throttledEventHandler;
}

// node_modules/ftdomdelegate/main.js
function Delegate(root) {
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }
  this.handle = Delegate.prototype.handle.bind(this);
  this._removedListeners = [];
}
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }
  this.rootElement = root;
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      this.rootElement.addEventListener(eventType, this.handle, true);
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      this.rootElement.addEventListener(eventType, this.handle, false);
    }
  }
  return this;
};
Delegate.prototype.captureForType = function (eventType) {
  return (
    ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
      eventType
    ) !== -1
  );
};
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;
  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }
  if (useCapture === void 0) {
    useCapture = this.captureForType(eventType);
  }
  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }
  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, useCapture);
    }
    listenerMap[eventType] = [];
  }
  if (!selector) {
    matcherParam = null;
    matcher = matchesRoot.bind(this);
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }
  listenerMap[eventType].push({
    selector,
    handler,
    matcher,
    matcherParam,
  });
  return this;
};
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }
  if (useCapture === void 0) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }
    return this;
  }
  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];
    if (
      (!selector || selector === listener.selector) &&
      (!handler || handler === listener.handler)
    ) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }
  if (!listenerList.length) {
    delete listenerMap[eventType];
    if (this.rootElement) {
      this.rootElement.removeEventListener(
        eventType,
        this.handle,
        useCapture
      );
    }
  }
  return this;
};
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";
  if (event[eventIgnore] === true) {
    return;
  }
  target = event.target;
  if (target.nodeType === 3) {
    target = target.parentNode;
  }
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }
  root = this.rootElement;
  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);
  switch (phase) {
    case 1:
      listenerList = this.listenerMap[1][type];
      break;
    case 2:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3:
      listenerList = this.listenerMap[0][type];
      break;
  }
  let toFire = [];
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];
      if (!listener) {
        break;
      }
      if (
        target.tagName &&
        ["button", "input", "select", "textarea"].indexOf(
          target.tagName.toLowerCase()
        ) > -1 &&
        target.hasAttribute("disabled")
      ) {
        toFire = [];
      } else if (
        listener.matcher.call(target, listener.matcherParam, target)
      ) {
        toFire.push([event, target, listener]);
      }
    }
    if (target === root) {
      break;
    }
    l = listenerList.length;
    target = target.parentElement || target.parentNode;
    if (target instanceof HTMLDocument) {
      break;
    }
  }
  let ret;
  for (i = 0; i < toFire.length; i++) {
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }
  return ret;
};
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      element === document ||
      element === document.documentElement ||
      element === window
    );
  }
  return this.rootElement === element;
}
function matchesId(id, element) {
  return id === element.id;
}
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};
var main_default = Delegate;

// js/custom-element/custom-html-element.js
var CustomHTMLElement = class extends HTMLElement {
  constructor() {
    super();
    this._hasSectionReloaded = false;
    if (Shopify.designMode) {
      this.rootDelegate.on("shopify:section:select", (event) => {
        const parentSection = this.closest(".shopify-section");
        if (event.target === parentSection && event.detail.load) {
          this._hasSectionReloaded = true;
        }
      });
    }
  }
  get rootDelegate() {
    return (this._rootDelegate =
      this._rootDelegate || new main_default(document.documentElement));
  }
  get delegate() {
    return (this._delegate = this._delegate || new main_default(this));
  }
  showLoadingBar() {
    triggerEvent(document.documentElement, "theme:loading:start");
  }
  hideLoadingBar() {
    triggerEvent(document.documentElement, "theme:loading:end");
  }
  untilVisible(
    intersectionObserverOptions = { rootMargin: "30px 0px", threshold: 0 }
  ) {
    const onBecameVisible = () => {
      this.classList.add("became-visible");
      this.style.opacity = "1";
    };
    return new Promise((resolve) => {
      if (window.IntersectionObserver) {
        this.intersectionObserver = new IntersectionObserver((event) => {
          if (event[0].isIntersecting) {
            this.intersectionObserver.disconnect();
            requestAnimationFrame(() => {
              resolve();
              onBecameVisible();
            });
          }
        }, intersectionObserverOptions);
        this.intersectionObserver.observe(this);
      } else {
        resolve();
        onBecameVisible();
      }
    });
  }
  disconnectedCallback() {
    var _a;
    this.delegate.destroy();
    this.rootDelegate.destroy();
    (_a = this.intersectionObserver) == null ? void 0 : _a.disconnect();
    delete this._delegate;
    delete this._rootDelegate;
  }
};


// js/custom-element/section/gallery/gallery-list.js
var GalleryList = class extends HTMLElement {
  connectedCallback() {
    this.listItems = Array.from(this.querySelectorAll("gallery-item"));
    this.scrollBarElement = this.querySelector(".gallery__progress-bar");
    this.listWrapperElement = this.querySelector(".gallery__list-wrapper");
    this.count = this.querySelector(".gallery__count");
    if (this.listItems.length > 1) {
      this.addEventListener(
        "scrollable-content:progress",
        this._updateProgressBar.bind(this)
      );
      this.addEventListener("prev-next:prev", this.previous.bind(this));
      this.addEventListener("prev-next:next", this.next.bind(this));
      if (Shopify.designMode) {
        this.addEventListener("shopify:block:select", (event) =>
          this.select(event.target.index, !event.detail.load)
        );
      }
    }
    if (this.count) {
      this.count.textContent = `1 / ${this.listItems.length}`;
    }
    const performancerCards = this.querySelectorAll(".performancer-card");
    if (performancerCards.length > 0) {
      performancerCards.forEach(e => {
        e.addEventListener("click", (event) => {
          if (e.classList.contains("active")) {
            e.classList.remove("active");
          } else {
            e.classList.add("active");
          }
        });
      })
    }
  }
  previous() {
    this.select(
      [...this.listItems]
        .reverse()
        .find((item) => item.isOnLeftHalfPartOfScreen).index
    );
  }
  next() {
    this.select(
      this.listItems.findIndex((item) => item.isOnRightHalfPartOfScreen)
    );
  }
  select(index, animate = true) {
    const boundingRect = this.listItems[index].getBoundingClientRect();
    this.listWrapperElement.scrollBy({
      behavior: animate ? "smooth" : "auto",
      left: Math.floor(
        boundingRect.left - window.innerWidth / 2 + boundingRect.width / 2
      ),
    });
    if (this.count) {
      this.count.textContent = `${index} / ${this.listItems.length}`;
    }
  }
  _updateProgressBar(event) {
    var _a;
    (_a = this.scrollBarElement) == null
      ? void 0
      : _a.style.setProperty("--transform", `${event.detail.progress}%`);
  }
};
window.customElements.define("gallery-list", GalleryList);

// js/custom-element/section/gallery/gallery-item.js
var GalleryItem = class extends HTMLElement {
  get index() {
    return [...this.parentNode.children].indexOf(this);
  }
  get isOnRightHalfPartOfScreen() {
    if (window.themeVariables.settings.direction === "ltr") {
      return this.getBoundingClientRect().left > window.innerWidth / 2;
    } else {
      return this.getBoundingClientRect().right < window.innerWidth / 2;
    }
  }
  get isOnLeftHalfPartOfScreen() {
    if (window.themeVariables.settings.direction === "ltr") {
      return this.getBoundingClientRect().right < window.innerWidth / 2;
    } else {
      return this.getBoundingClientRect().left > window.innerWidth / 2;
    }
  }
};
window.customElements.define("gallery-item", GalleryItem);

// js/custom-element/ui/scrollable-content.js
var ScrollableContent = class extends CustomHTMLElement {
  connectedCallback() {
    if (this.draggable) {
      this._setupDraggability();
    }
    this._checkScrollability();
    window.addEventListener("resize", this._checkScrollability.bind(this));
    this.addEventListener(
      "scroll",
      throttle(this._calculateProgress.bind(this), 15)
    );
  }
  get draggable() {
    return this.hasAttribute("draggable");
  }
  _setupDraggability() {
    this.insertAdjacentHTML(
      "afterend",
      '<drag-cursor hidden class="custom-drag-cursor"></drag-cursor>'
    );
    const mediaQuery = matchMedia("(hover: none)");
    mediaQuery.addListener(this._onMediaChanges.bind(this));
    if (!mediaQuery.matches) {
      this._attachDraggableListeners();
    }
  }
  _attachDraggableListeners() {
    this.delegate.on("mousedown", this._onMouseDown.bind(this));
    this.delegate.on("mousemove", this._onMouseMove.bind(this));
    this.delegate.on("mouseup", this._onMouseUp.bind(this));
  }
  _removeDraggableListeners() {
    this.delegate.off("mousedown");
    this.delegate.off("mousemove");
    this.delegate.off("mouseup");
  }
  _checkScrollability() {
    this.classList.toggle(
      "is-scrollable",
      this.scrollWidth > this.offsetWidth
    );
  }
  _calculateProgress() {
    const scrollLeft =
      this.scrollLeft *
      (window.themeVariables.settings.direction === "ltr" ? 1 : -1);
    const progress =
      Math.max(
        0,
        Math.min(1, scrollLeft / (this.scrollWidth - this.clientWidth))
      ) * 100;
    triggerEvent(this, "scrollable-content:progress", { progress });
  }
  _onMediaChanges(event) {
    if (!event.matches) {
      this._attachDraggableListeners();
    } else {
      this._removeDraggableListeners();
    }
  }
  _onMouseDown(event) {
    if (event.target && event.target.nodeName === "IMG") {
      event.preventDefault();
    }
    this.startX = event.clientX + this.scrollLeft;
    this.diffX = 0;
    this.drag = true;
  }
  _onMouseMove(event) {
    if (this.drag) {
      this.diffX = this.startX - (event.clientX + this.scrollLeft);
      this.scrollLeft += this.diffX;
    }
  }
  _onMouseUp() {
    this.drag = false;
    let start = 1;
    let animate = () => {
      let step = Math.sinh(start);
      if (step <= 0) {
        window.cancelAnimationFrame(animate);
      } else {
        this.scrollLeft += this.diffX * step;
        start -= 0.03;
        window.requestAnimationFrame(animate);
      }
    };
    animate();
  }
};
window.customElements.define("scrollable-content", ScrollableContent);

// js/custom-element/behavior/prev-next-buttons.js
var PrevNextButtons = class extends HTMLElement {
  connectedCallback() {
    this.prevButton = this.querySelector("button:first-of-type");
    this.nextButton = this.querySelector("button:last-of-type");
    this.prevButton.addEventListener("click", () =>
      this.prevButton.dispatchEvent(
        new CustomEvent("prev-next:prev", { bubbles: true })
      )
    );
    this.nextButton.addEventListener("click", () =>
      this.nextButton.dispatchEvent(
        new CustomEvent("prev-next:next", { bubbles: true })
      )
    );
  }
  set isPrevDisabled(value) {
    this.prevButton.disabled = value;
  }
  set isNextDisabled(value) {
    this.nextButton.disabled = value;
  }
};
var PrevButton = class extends HTMLButtonElement {
  connectedCallback() {
    this.addEventListener("click", () =>
      this.dispatchEvent(new CustomEvent("prev-next:prev", { bubbles: true }))
    );
  }
};
var NextButton = class extends HTMLButtonElement {
  connectedCallback() {
    this.addEventListener("click", () =>
      this.dispatchEvent(new CustomEvent("prev-next:next", { bubbles: true }))
    );
  }
};
window.customElements.define("prev-next-buttons", PrevNextButtons);
window.customElements.define("prev-button", PrevButton, {
  extends: "button",
});
window.customElements.define("next-button", NextButton, {
  extends: "button",
});

class FestivalSchedule extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    // 显示条数限制
    this.showContentLimit = this.getAttribute('show-content-limit') || 4;
    // 获取所有内容
    this.allContent = Array.from(this.querySelectorAll('.day-content'));

    this.showAllButton = this.querySelector('.schedule-button');

      // 点击显示全部按钮
    this.showAllButton.addEventListener('click', () => {
      this.displayContent(this.currentTabContent);
      // this.showAllButton.style.display = 'none';
    });
    this.currentDate = null;
    this.dayTabs = this.querySelectorAll('.festival-schedule-section .day-tab');
    this.currentTabContent = []
    this.showContent = []
    // 默认选中第一个tab
    this.selectTab(this.dayTabs[0])
    this.dayTabs.forEach(tab => { 
      tab.addEventListener('click', () => {
        this.selectTab(tab)
      })
    })
  }
  selectTab(tab) {
    this.dayTabs.forEach(t => t.classList.remove('active'));
    tab.classList.add('active');

    this.currentDate = tab.getAttribute('data-target');
    this.currentTabContent = this.allContent.filter((e) => e.getAttribute('data-target') === this.currentDate);
    this.showContent = this.currentTabContent.filter((e, index) => index < this.showContentLimit);
    this.displayContent(this.showContent);

    if (this.currentTabContent.length > this.showContentLimit) {
      this.showAllButton.style.display = 'block';
    } else {
      // this.showAllButton.style.display = 'none';
    }

  }
  displayContent(contents) {
    this.allContent.forEach(e => e.classList.remove('active'));
    contents.forEach((e, index) => e.classList.add('active'));
  }
} 
window.customElements.define('festival-schedule', FestivalSchedule);

class copyButton extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.addEventListener('click', async () => {
      const copyText = this.getAttribute('copy-data-text');
      console.log('折扣码',copyText)
      try {
        // 使用现代的Clipboard API
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(copyText);
          this.textContent = 'Copied!';

        } else {
          // 降级方案：使用传统的document.execCommand
          this.fallbackCopyTextToClipboard(copyText);
        }
      } catch (err) {
        console.error('Failed to copy discount code: ', err);
        // 可以在这里添加错误提示
      }
    });
  }
  fallbackCopyTextToClipboard(text) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    
    // 避免滚动到底部
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';
    
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    this.textContent = 'Copied!';
    
    try {
      document.execCommand('copy');
    } catch (err) {
      console.error('Fallback: Could not copy text: ', err);
    }
    
    document.body.removeChild(textArea);
  }

}
window.customElements.define('copy-button', copyButton);


window.customElements.define(
  "common-swiper",
  class CommonSwiper extends HTMLElement {
    // 函数返回避免数据共享
    static config = () => ({
      slidesPerView: 1,
      spaceBetween: 10,
      breakpoints: {
        768: {
          spaceBetween: 24,
        },
        1240: {
          spaceBetween: 32,
        },
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    constructor() {
      super();

      this.only_mobile = this.hasAttribute("only-mobile");
    }
    connectedCallback() {
      if (this.only_mobile && window.innerWidth > 768) return;
      this.container = this.querySelector(".swiper");
      if (!this.container) return;
      if (!this.querySelectorAll(".swiper-slide")?.length) return;
      this.initSwiper();
    }
    initSwiper() {
      this.config = this.getConfig();
      this.swiper = new Swiper(this.container, this.config);
    }

    getConfig() {
      let config =
        JSON.parse(
          this.querySelector("script[data-swiper-config]")?.textContent || null
        ) || null;
      config = config || CommonSwiper.config();
      if (config.navigation) {
        // 判断config.navigation.nextEl是dom对象还是字符串
        if (typeof config.navigation.nextEl === "string") {
          config.navigation.nextEl = this.querySelector(
            config.navigation.nextEl
          );
        }
        if (typeof config.navigation.prevEl === "string") {
          config.navigation.prevEl = this.querySelector(
            config.navigation.prevEl
          );
        }
      }
      if (config.scrollbar) {
        // 判断config.pagination.el是dom对象还是字符串
        if (typeof config.scrollbar.el === "string") {
          config.scrollbar.el = this.querySelector(config.scrollbar.el);
        }
      }
      if (this.querySelector(".swiper-pagination")) {
        config.pagination = {
          el: this.querySelector(".swiper-pagination"),
          clickable: true,
        };
      } else {
        delete config.pagination;
      }
      return config;
    }
  }
);
